import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
// add filters
import filters from './global/filters/filters'
//materialdesignicons
import '@mdi/font/css/materialdesignicons.css'
//custom css
import './assets/css/variables.scss'

import { registerModules } from "./register-modules";

import userModeule from "./modules/user";
import DashBoardModeule from "./modules/DashBoard";

import VueSweetalert2 from "./plugins/sweetalert";
import Vuetify from 'vuetify/lib'
import 'vuetify/dist/vuetify.min.css'

const vuetifyOptions = {
  theme: {
      themes: {
          light: {
              primary: "#292961",
              secondary: "#3cbd9c",
              manuBackground: '#F3F5F8',
              titleText: '#505D6F',
              menuActive: '#51A7F8',
              blue: '#51A7F8',
              darkGrey: '#9AA1A9'
          }
      }
  },
}




registerModules({
  
  user:userModeule,
  DashBoardModeule:DashBoardModeule,
});

Vue.config.productionTip = false
Vue.use(Vuetify)
new Vue({
  router,
  store,
  vuetify: new Vuetify(vuetifyOptions),
  VueSweetalert2,
  filters,
  render: h => h(App)
}).$mount("#app");
